import Navbar from "../sections/web_core/Navbar";
import SecondHeroSection from "../sections/web_core/SecondHeroSection";
import IMAGE_1 from "../Assets/Courses/imgi_25_page-title.jpg";
import Footer from "../sections/web_core/Footer";
import FeaturesSection from "../sections/web_core/FeatureSection";
import InstructorsSection from "../sections/scholar_comp/InstructorSection";
import ReviewsSection from "../sections/web_core/ReviewSection";
import PricingRow from "../sections/pricing_component/PricicngRow";
import Aboutmain from "../sections/web_core/aboutmain";

/* =========================
   Section Wrapper
========================= */
const SectionWrapper = ({ children, className = "" }) => {
  return (
    <section className={`w-full mb-[5px] ${className}`}>
      {children}
    </section>
  );
};

const About = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">

      <Navbar />

      <SectionWrapper>
        <SecondHeroSection
          title="About"
          subtitle="Explore our wide range of professional courses"
          bgImage={IMAGE_1}
          breadcrumbs={[
            { label: "Home", href: "/" },
            { label: "About" },
          ]}
        />
      </SectionWrapper>

      <SectionWrapper>
        <Aboutmain />
      </SectionWrapper>

      <SectionWrapper>
        <FeaturesSection />
      </SectionWrapper>

      <SectionWrapper>
        <InstructorsSection />
      </SectionWrapper>

      <SectionWrapper>
        <PricingRow size="small" limit={3} />
      </SectionWrapper>

      <SectionWrapper>
        <ReviewsSection />
      </SectionWrapper>

      <Footer />

    </div>
  );
};

export default About;